import styled from 'styled-components'
import breakpoints from '../../config/settings/breakpoints'

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ theme }) => theme.colors.textPrimary};
  background:
    radial-gradient(ellipse 80% 50% at 50% -5%, rgba(62, 207, 142, 0.16), transparent 55%),
    radial-gradient(ellipse 45% 35% at 100% 20%, rgba(62, 207, 142, 0.07), transparent 50%),
    ${({ theme }) => theme.colors.main};
`

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(33, 38, 45, 0.92)'
      : 'rgba(255, 255, 255, 0.92)'};
  backdrop-filter: blur(10px);
`

export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0.75rem 1rem;

  @media ${breakpoints.device.sm} {
    padding: 1rem 1.5rem;
  }
`

export const Main = styled.main`
  flex: 1;
  width: 100%;
`

export const Footer = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
`

export const FooterInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.75rem 1rem 2.25rem;

  @media ${breakpoints.device.sm} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 2.5rem 1.5rem 3rem;
  }
`
